import { useNavigate } from 'react-router-dom';
import logo from '../../Images/logo.png';
import React, { useState, useEffect } from 'react';

import {
  FaInfoCircle,
  FaBars,
  FaHireAHelper,
  FaUsers,
  FaPlane
} from 'react-icons/fa';

function Header({ isOpen, setIsOpen }) {
  const [isPakageOpen, setIsPakageOpen] = useState(false);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  const categories = [
    { label: 'Domestic Packages', path: '/domestic-form' },
    { label: 'International Packages', path: '/international-form' },
    { label: 'Religious Packages', path: '/religious-form' }
  ];

  // Load user from localStorage only (NO redirect)
  useEffect(() => {
    window.scrollTo(0, 0);

    const savedUser = localStorage.getItem('travchap_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleAccountClick = () => {
    if (user) {
      navigate('/account');
    } else {
      navigate('/login');
    }
  };

  return (
    <header className="bg-white text-gray-800 shadow-md fixed top-0 right-0 left-0 z-30">
      <div className="flex justify-between items-center sm:pl-4 md:px-16">
        <div className="flex items-center gap-8 md:gap-8">
          <FaBars
            className="text-3xl cursor-pointer block md:hidden mt-3 text-[#40858a]"
            onClick={() => setIsOpen(!isOpen)}
          />
          <div className="flex text-base items-end">
            <div className="flex items-end leading-tight">
              <img
                src={logo}
                alt="Logo"
                className="cursor-pointer h-24 w-auto object-contain"
                onClick={() => navigate('/')}
              />
              <div className="text-[12px] pt-2 flex gap-1 -ml-1 mb-2  tracking-wide font-bold font-serif">
                <p>BY</p>
                <p>SAFARNAAMA</p>
                <p>HOLIDAYS</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div
            className="hidden sm:flex items-center gap-1 cursor-pointer"
            onClick={() => navigate('/round-trip')}
          >
            <FaPlane />
            <p className="text-[14px] text-gray-700 font-bold">
              Round Trip Special Flight
            </p>
          </div>

          <div
            className="relative sm:block hidden"
            onMouseEnter={() => setIsPakageOpen(true)}
            onMouseLeave={() => setIsPakageOpen(false)}
          >
            <div className="flex items-center font-bold text-[14px] gap-2 cursor-pointer px-3 py-2 hover:text-teal-600">
              <FaUsers />
              <h2>Group Package Request</h2>
            </div>

            {isPakageOpen && (
              <div className="absolute left-0 w-60 bg-white shadow-lg rounded-lg border z-50">
                <ul className="flex flex-col">
                  {categories.map((cat, index) => (
                    <li
                      key={index}
                      onClick={() => navigate(cat.path)}
                      className="px-4 py-2 hover:bg-pink-100 cursor-pointer  hover:font-medium text-gray-700"
                    >
                      {cat.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div
            className="hidden lg:flex items-center gap-1 cursor-pointer"
            onClick={() => navigate('/about')}
          >
            <FaInfoCircle />
            <p className="text-[14px] font-medium text-gray-700">About Us</p>
          </div>

          {/* Help */}
          <div
            className="hidden lg:flex items-center gap-1 cursor-pointer"
            onClick={() => navigate('/help')}
          >
            <FaHireAHelper />
            <p className="text-[14px] font-medium text-gray-700">Help</p>
          </div>

          <div
            onClick={handleAccountClick}
            className="flex items-center gap-3 px-4 py-2 rounded-xl cursor-pointer
             bg-white shadow-sm hover:shadow-md transition border border-gray-200"
          >
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
              <span className="text-xl">👤</span>
            </div>

            {user ? (
              <div className="leading-tight">
                <p className="text-gray-500 text-sm">Welcome</p>
                <p className="font-semibold text-gray-800">{user.full_name}</p>
              </div>
            ) : (
              <p className="font-semibold text-gray-700">Login</p>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
